import request from '@/utils/request'

// 조회
export function getWorkerCheckManage(params, isProgress) {
  return request({
    url: `/api/getWorkerCheckManage`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}

// task 처리
export function saveWorkerCheckManage(params, isProgress) {
  return request({
    url: `/api/saveWorkerCheckManage`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' }
  })
}

